import React from 'react';
import { Result, Typography } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';

const { Paragraph, Text } = Typography;

const SUPPORT_URL = 'https://support.butlr.io/hc/en-us/requests/new';

export const NoSpacesAvailable: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-full h-full min-h-[400px]">
      <Result
        icon={<InfoCircleFilled style={{ color: '#1890ff', fontSize: 72 }} />}
        title="No Spaces Available"
        subTitle={
          <>
            You don&apos;t have access to any spaces yet.
            <br />
            This can happen if no spaces are assigned to you, or if your organization hasn&apos;t
            set up any spaces.
          </>
        }
        style={{ maxWidth: 720 }}
      >
        <div className="text-left" style={{ padding: '0 8px' }}>
          <Text strong style={{ fontSize: 16 }}>
            What can I do?
          </Text>
          <Paragraph style={{ marginTop: 14, marginBottom: 0 }}>
            <ul style={{ paddingLeft: 20, margin: 0 }}>
              <li style={{ lineHeight: '32px' }}>
                If you&apos;re an owner or admin, please set up spaces for this organization.
              </li>
              <li style={{ lineHeight: '32px' }}>
                If you&apos;re a member, please contact your organization admin to request access
              </li>
              <li style={{ lineHeight: '32px' }}>
                If you believe this is an error, please contact{' '}
                <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer">
                  Customer Support
                </a>
                .
              </li>
            </ul>
          </Paragraph>
        </div>
      </Result>
    </div>
  );
};

export default NoSpacesAvailable;
